import React from 'react';
import DiscountCode from 'components/purchase/DiscountCode';

/**
 * QuickCheckoutDiscount component.
 * Renders the discount-code input inside the quick checkout body, beside the other things that
 * change the total. It lives here rather than in `PurchaseSidebar` because the sidebar is absent on
 * the two surfaces Quick Purchase actually uses: the modal launched from search results never mounts
 * one, and below the `large` breakpoint it is hidden.
 *
 * The step is declared rather than derived. In modal mode the browser is still on the search-results
 * route, so a pathname lookup would resolve to no step at all and suppress the input.
 * @returns {JSX.Element} The discount-code input for the quick checkout.
 */
const QuickCheckoutDiscount = () => <DiscountCode purchaseStep="quickCheckout" />;

export default QuickCheckoutDiscount;
